import * as Yup from "yup";

const AddCompanyPolicyScheduleValidator = Yup.object({
  policy_id : Yup.string()
    .required("Policy is Required"),
  start_date : Yup.string()
    .required("Start Date is Required"),
  end_date : Yup.string()
    .required("End Date is Required")
    .test(
      "is-endDate-after-startDate",
      "End Date must be greater than Start Date",
      function (value) {
        const { start_date } = this.parent;
        if (!start_date || !value) {
          return true; // Skip validation if either date is not provided
        }
        const start = new Date(start_date);
        const end = new Date(value);
        return end > start;
      }
    ),
});

export default AddCompanyPolicyScheduleValidator;